import DisabledUsersParentNodeRenderer from "../../hierarchySelector/userSelector/DisabledUsersParentNodeRenderer";
import {disableTextSelection} from '../../atBrowserUtils'

export default class DisabledUsersParentNodeRendererWithoutCheckbox extends DisabledUsersParentNodeRenderer {

    generateContent(treeNode, targetEl) {
        const triStateEl = document.createElement("a");
        triStateEl.hidefocus = "true";
        triStateEl.onfocus = function() { this.blur() };
        disableTextSelection(triStateEl, true);

        const labelEl = document.createElement("span");
        labelEl.className = "ellipsisLabel";
        this.generateLabel(treeNode, labelEl);

        targetEl.appendChild(triStateEl);
        triStateEl.appendChild(labelEl);

        this.appendAdditionalElements(targetEl, treeNode);

        this.tree.getUIObjectForNode(treeNode).cbEl = triStateEl;
        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/DisabledUsersParentNodeRendererWithoutCheckbox.js